<template>
    <div class="echartsBox">
        <div ref="ecahrts" class="ecahrts" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import * as methods from './method.js'
import 'echarts-gl';
require('echarts/lib/chart/bar.js');
require('echarts/lib/component/title.js');
require('echarts/lib/component/tooltip.js');
export default {
    // 3d柱形图2
    name: 'template.scope24',
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata
        }
        this.setData()
        this.Drawecharts();
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n
        },
        defaultdata(n) {
            this.Drawecharts()
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    },
    data() {
        return {
            title: '3d柱形图-scope24',
            timer: null,
            defaultdata: [
                { value1: '4月', value2: '系列一', value3: '10', value4: '系列二', value5: '20', value6: '%' },
                { value1: '5月', value2: '系列一', value3: '20', value4: '系列二', value5: '30' },
                { value1: '6月', value2: '系列一', value3: '30', value4: '系列二', value5: '40' },
                { value1: '7月', value2: '系列一', value3: '40', value4: '系列二', value5: '50' },
                { value1: '8月', value2: '系列一', value3: '50', value4: '系列二', value5: '60' }
            ],
            valueMap: [
                { name: '横轴', key: 'value1' },
                { name: '柱图1', key: 'value2' },
                { name: '柱图1数值', key: 'value3' },
                { name: '柱图2', key: 'value4' },
                { name: '柱图2数值', key: 'value5' },
                { name: '单位', key: 'value6' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
        }
    },
    methods: {
        ...methods,
        Drawecharts() {
            clearInterval(this.timer);
            this.timer = null;
            var TmyChart = echarts.init(this.$refs.ecahrts);
            let charData = this.defaultdata;
            var barWidth = 15;
            let data1 = [];
            let data2 = [];
            let legend = [];
            let unit = this.defaultdata[0].value6 || ''
            const defaultdata = this.defaultdata;
            this.defaultdata.forEach((item, i) => {
                if (item.value2 && item.value3) {
                    const vdata1 = { name: item.value2, value: item.value3 };
                    data1.push(vdata1);
                }
                if (item.value4 && item.value5) {
                    const vdata2 = { name: item.value4, value: item.value5 };
                    data2.push(vdata2);
                }
                if (i == 0) {
                    if (item.value2) {
                        legend.push({
                            top: "2%",
                            right: "50%",
                            itemHeight: 12, //图例的高度  文字左边那个
                            itemWidth: 10,
                            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                            data: [{ name: item.value2, icon: "rect" }],
                        });
                    }
                    if (item.value4) {
                        legend.push({
                            top: "2%",
                            left: "50%",
                            itemHeight: 12, //图例的高度  文字左边那个
                            itemWidth: 10,
                            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                            data: [{ name: this.defaultdata[0].value4, icon: "rect" }],
                        });
                    }
                }
            });
            const xAxis = this.defaultdata.map((item) => {
                return item.value1;
            });
            const percent = (7 / xAxis.length) * 100;
            let zoom = [
                {
                    id: "scope3", // 唯一的id
                    filterMode: "empty",
                    xAxisIndex: [0], //滑动条为竖
                    mayValueSpan: 7, // 显示数据的条数(默认显示10个)
                    type: "slider",

                    showDetail: false, //关闭：拖拽时候显示详细数值信息。
                    dataBackground: {
                        show: false,
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    selectedDataBackground: {
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },

                    backgroundColor: "transparent",
                    fillerColor: "transparent",
                    borderColor: "transparent",
                    start: 0,
                    end: percent,
                    top: "80%",
                    height: "5%",
                },
            ];
            let Toption = {
                title: [
                    {
                        text: unit,
                        top: "0",
                        left: "0",
                        textStyle: {
                            color: "#979AA0",
                            fontSize: 12,
                        },
                    },
                ],
                grid: {
                    left: "5px",
                    right: "10px",
                    bottom: "0px",
                    top: "40px",
                    containLabel: true,
                },
                tooltip: {
                    formatter: function (params) {
                        let name1 = "";
                        let name2 = "";
                        if (defaultdata[0].value2 && defaultdata[0].value3) {
                            name1 =
                                "名称：" +
                                params.name +
                                "<br/>" +
                                defaultdata[0].value2 +
                                "：" +
                                data1[params.dataIndex].value;
                        }
                        if (defaultdata[0].value4 && defaultdata[0].value5) {
                            name2 =
                                "<br/>" +
                                defaultdata[0].value4 +
                                "：" +
                                data2[params.dataIndex].value;
                        }
                        return name1 + name2;
                    },
                },
                legend: [...legend],
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: charData.map((item) => {
                        return item.value1;
                    }),
                    axisLabel: {
                        interval: 0,
                        width: 45,
                        overflow: 'truncate', //文字超出宽度截断，默认为...
                        
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                            fontSize: "14",
                            lineHeight: 16,
                        },
                        formatter: function (value) {
                            return value
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            // X 轴颜色配置
                            color: "#4792e9",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "value",
                    splitNumber: 5, // 设置 Y 轴分割线的数量
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#15205B",
                        },
                    },
                    // nameTextStyle: {
                    //     color: "#B0B5BB",
                    //     nameLocation: "start",
                    //     padding: [0, 0, 0, -40]
                    // },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: "rgba(135,140,147,1)", //左侧显示线
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        formatter: "{value}",
                        textStyle: {
                            color: "#c9c9c9",
                            fontSize: 10,
                        },
                    },
                },
                series: [
                    //blue zz
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [barWidth, 10],
                        symbolOffset: [-9, -5.5],
                        symbolPosition: "end",
                        z: 20,
                        color: "#078eda",
                        data: data1.map((item) => {
                            return item.value;
                        }),
                    },
                    // green zz
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        // symbolSize: [barWidth, 8],
                        // symbolOffset: [9.5, -4.5],
                        symbolSize: [barWidth, 10],
                        symbolOffset: [9, -5.5],
                        z: 20,
                        color: "#11e3e2",
                        symbolPosition: "end",
                        data: data2.map((item) => {
                            return item.value;
                        }),
                    },

                    // ------------------
                    // bottom
                    {
                        name: this.defaultdata[0].value2 || "",
                        type: "bar",
                        barWidth: barWidth,
                        itemStyle: {
                            normal: {
                                opacity: 1,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                    {
                                        offset: 0,
                                        color: "#0980f8",
                                    },
                                    {
                                        offset: 0.49,
                                        color: "#0980f8",
                                    },
                                    {
                                        offset: 0.5,
                                        color: "#0980f8",
                                    },
                                    {
                                        offset: 0.51,
                                        color: "#095baf",
                                    },
                                    {
                                        offset: 1,
                                        color: "#095baf",
                                    },
                                ]),
                                barBorderRadius: 0,
                            },
                        },
                        data: data1.map((item) => {
                            return item.value;
                        }),
                    },
                    {
                        data: data2.map((item) => {
                            return item.value;
                        }),
                        type: "bar",
                        name: this.defaultdata[0].value4 || "",
                        barWidth: barWidth,
                        itemStyle: {
                            normal: {
                                opacity: 1,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                    {
                                        offset: 0,
                                        color: "#07a1a3",
                                    },
                                    {
                                        offset: 0.49,
                                        color: "#07a1a3",
                                    },
                                    {
                                        offset: 0.5,
                                        color: "#07a1a3",
                                    },
                                    {
                                        offset: 0.51,
                                        color: "#0d4b4d",
                                    },
                                    {
                                        offset: 1,
                                        color: "#0d4b4d",
                                    },
                                ]),
                                barBorderRadius: 0,
                            },
                        },
                    },
                ],
                dataZoom: xAxis.length > 7 ? zoom : [],
            };
            TmyChart.on("legendselectchanged", (data) => {
                let datamap = Object.keys(data.selected);
                if (
                    data.selected[datamap[0]] == false &&
                    data.selected[datamap[1]] == false
                ) {
                    //1,2都不选
                    Toption.series[0].data = [];
                    Toption.series[1].data = [];
                    Toption && TmyChart.setOption(Toption);
                } else if (
                    data.selected[datamap[0]] == true &&
                    data.selected[datamap[1]] == false
                ) {
                    //1选2不选}
                    Toption.series[0].data = data1;
                    Toption.series[1].data = [];
                    Toption.series[0].symbolOffset = [0, -5.5];
                    Toption && TmyChart.setOption(Toption);
                } else if (
                    data.selected[datamap[0]] == false &&
                    data.selected[datamap[1]] == true
                ) {
                    //1不选2选
                    Toption.series[0].data = [];
                    Toption.series[1].data = data2;
                    Toption.series[1].symbolOffset = [0, -5.5];
                    Toption && TmyChart.setOption(Toption);
                } else if (
                    data.selected[datamap[0]] == true &&
                    data.selected[datamap[1]] == true
                ) {
                    //1,2都选
                    Toption.series[0].data = data1;
                    Toption.series[1].data = data2;
                    Toption.series[1].symbolOffset = [9, -5.5];
                    Toption.series[0].symbolOffset = [-9, -5.5];
                    Toption && TmyChart.setOption(Toption);
                }
            });
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(() => {
                if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);
        },
    },

}
</script>

<style scoped>
.echartsBox {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    position: relative;
    overflow: hidden;
}

.ecahrts {
    width: 100%;
    height: 100%;
}
</style>